const UHC = 'UHC';
const SPECTERA = 'SPECTERA';
const LFG = 'LFG';
const MEDIGOLD = 'MEDIGOLD';
const SOLSTICE = 'SOLSTICE';

export const UHC_COOKIE = {
    KEY: 'in_network',
    VALUES: {
        LFG,
        MEDIGOLD,
        SOLSTICE,
        SPECTERA,
        UHC,
    },
} as const;

type BenefitsBrandsType = {
    [key: string]: {brand: string; brandName: string; url: string};
};

export const BENEFITS_BRANDS: BenefitsBrandsType = {
    LFG: {
        brand: 'lfg',
        brandName: 'Lincoln Financial Group',
        url: '/lfg',
    },
    MEDIGOLD: {
        brand: 'medigold',
        brandName: 'MediGold',
        url: '/medigold',
    },
    SOLSTICE: {
        brand: 'solstice',
        brandName: 'Solstice',
        url: '/solstice',
    },
    SPECTERA: {
        brand: 'spectera',
        brandName: 'Spectera',
        url: '/spectera',
    },
    UHC: {
        brand: 'uhc',
        brandName: 'UnitedHealthcare',
        url: '/uhc',
    },
} as const;
